export default function getResource(label, vars = []) {
    const resources = {
        estimatedTotal: 'Total estimé',
        googlePayErrorMessage:
            'Nous n’avons pas été en mesure de passer votre commande. Problème de connexion à Google Pay. Veuillez utiliser un autre mode de paiement ou réessayer plus tard.<br /><br />S’il y a lieu, nous avons reversé tout frais en cours sur votre compte.',
        googlePayErrorOkButton: 'OK',
        googlePayErrorTitle: 'Erreur',
        googlePayGenericError: 'Une erreur s’est produite. Veuillez réessayer.',
        googlePayRenderErrorMessage: 'Impossible de sélectionner Google Pay. Veuillez réessayer ou choisir un autre mode de paiement.',
        payWithGooglePay: 'Payez avec Google Pay',
        shippingOptionPlaceholderDescription: 'Enter address to see options',
        shippingOptionPlaceholderLabel: 'Calculating…',
        total: 'Total'
    };

    return resources[label];
}
